import { Stack } from '@mui/material';
import { NotFoundError } from '@retail/components';
import { DocumentationTable, DocumentationTableSkeleton } from '@retail/products/components';
import { useFetchSupplierItemsDocumentation } from '@retail/products/data-access';
import { MgItemDocumentation } from '@retail/products/types';

interface Props {
  mgItemNumber: number;
}

export const DocumentationContainer = ({ mgItemNumber }: Props) => {
  const { data: supplierItemsDocumentationDTO, isLoading } = useFetchSupplierItemsDocumentation(
    { mgItemNumber },
    { suspense: false }
  );
  const mgItemDocumentation = supplierItemsDocumentationDTO
    ? MgItemDocumentation.fromDto(supplierItemsDocumentationDTO)
    : undefined;

  return (
    <Stack>
      {isLoading ? (
        <DocumentationTableSkeleton />
      ) : mgItemDocumentation ? (
        <DocumentationTable mgItemDocumentation={mgItemDocumentation} />
      ) : (
        <NotFoundError />
      )}
    </Stack>
  );
};
